// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
  },
};

(function () {
  // Add this
  BoostPFS.inject(this); // Add this

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
    if (!data) data = this.data; // Add this line
    if (!index) index = this.index; // Add this line
    if (!totalProduct) totalProduct = this.totalProduct;

    var soldOut = !data.available;
    var onSale = data.compare_at_price_min > data.price_min;
    var priceVaries = data.price_min != data.price_max;
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    itemHtml = itemHtml.replace(/{{gridItemWidth}}/g, boostPFSConfig.custom.grid_item_width);

    // Add class
    // Add Badges
    var itemBadgesHtml = '';
    if (boostPFSConfig.custom.enable_badges) {
      if (onSale && data.available) {
        itemBadgesHtml += boostPFSTemplate.saleLabelHtml.replace(
          /{{onSaleLabel}}/g,
          boostPFSConfig.label.on_sale,
        );
      } else if (!data.available) {
        itemBadgesHtml += boostPFSTemplate.soldOutLabelHtml.replace(
          /{{soldOutLabel}}/g,
          boostPFSConfig.label.sold_out,
        );
      }
    }
    itemHtml = itemHtml.replace(/{{itemBadges}}/g, itemBadgesHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.product_card_vendor
      ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
      : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
    // Add price
    itemHtml = itemHtml.replace(
      /{{itemPrice}}/g,
      boostPFSConfig.custom.product_card_price ? buildPrice(data, onSale, priceVaries) : '',
    );

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var itemReviewsHtml = boostPFSConfig.custom.show_reviews
        ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'
        : '';
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);
    }

    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

    // Add Quick view
    itemHtml = itemHtml.replace(/{{itemQuickview}}/g, buildQuickView(data, soldOut));

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(
      /{{itemTitle}}/g,
      boostPFSConfig.custom.product_card_title ? data.title : '',
    );
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    return itemHtml;
  };

  function buildImages(data) {
    var images = data.images_info;
    var html = '';
    if (boostPFSConfig.custom.hover_effect) {
      if (images.length > 1) {
        html += '<div class="reveal">';
        html +=
          '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
        html +=
          '<img src="' +
          Utils.optimizeImage(images[0]['src'], '760x') +
          '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
        html += '<div class="hidden">';
        html +=
          '<img src="' +
          Utils.optimizeImage(images[1]['src'], '760x') +
          '" alt="{{itemTitle}}" class="img-responsive" />';
        html += '</div>';
        html += '</a>';
        html += '</div>';
      } else {
        html +=
          '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
        html +=
          '<img src="' +
          Utils.getFeaturedImage(images, '760x') +
          '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
        html += '</a>';
      }
    } else {
      html += '<a href="{{itemUrl}}" title="{{itemTitle}}" class="grid__image grid__image__match">';
      html +=
        '<img src="' +
        Utils.getFeaturedImage(images, '760x') +
        '" alt="{{itemTitle}}" class="img-responsive wow fadeIn" id="collection-image-anim">';
      html += '</a>';
    }
    return html;
  }

  function buildQuickView(data, soldOut) {
    var html = '';
    if (boostPFSConfig.custom.product_card_button) {
      if (soldOut) {
        html +=
          '<div class="quick-add-wrapper" data-block-type="product_card_button">' +
          '<a class="quick-add-button-variants button button-primary" tabIndex="0" href="{{itemUrl}}">' +
          boostPFSConfig.label.view_options +
          '</a>' +
          '</div>';
      } else if (data.variants.length > 0) {
        html +=
          '<div class="quick-add-wrapper" data-block-type="product_card_button">' +
          '<a class="quick-add-button-variants button button-primary" tabIndex="0" href="{{itemUrl}}">' +
          boostPFSConfig.label.view_options +
          '</a>' +
          '</div>';
      } else {
        html +=
          '<div class="quick-add-wrapper is-singular" data-block-type="product_card_button">' +
          '<form method="post" action="/cart/add" id="CollectionAddToCartForm" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">' +
          '<input type="hidden" name="form_type" value="product">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="id" value="' +
          data.variants[0].id +
          '"/>' +
          '<button class="quick-add-button  button button-primary" type="submit" tabindex="0">' +
          boostPFSConfig.label.add_to_cart +
          '</button>' +
          '</form>' +
          '</div>';
      }
    }
    return html;
  }

  function buildPrice(data, onSale, priceVaries) {
    var html = '';
    if (onSale) {
      // if (priceVaries) {
      // 	html += boostPFSConfig.label.sale_from_price.replace( /{{ price }}/g, '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>');
      // else {
      html +=
        '<span class="product-grid--compare-price">' +
        Utils.formatMoney(data.compare_at_price_min) +
        '</span>';
      html += ' <span class="money">' + Utils.formatMoney(data.price_max) + '</span>';
      // }
    } else {
      if (priceVaries) {
        html +=
          ' <span class="product-grid--from-wrapper">' +
          boostPFSConfig.label.from_price +
          '</span> <span class="money">' +
          Utils.formatMoney(data.price_min) +
          '</span>';
      } else {
        html += '<span class="money">' + Utils.formatMoney(data.price_min) + '</span>';
      }
    }
    // console.log(html)
    return html;
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;

    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;
      // Build Previous
      var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : '';
      previousHtml = previousHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink('page', currentPage, currentPage - 1),
      );
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
      // Build Next
      var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : '';
      nextHtml = nextHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink('page', currentPage, currentPage + 1),
      );
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);
      var afterCurrentPageArr = [];
      for (
        var iAfter = currentPage + 1;
        iAfter < currentPage + 3 && iAfter <= totalPage;
        iAfter++
      ) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }
      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml +=
            pageArr[iPage] == currentPage
              ? boostPFSTemplate.pageItemSelectedHtml
              : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(
          /{{itemUrl}}/g,
          Utils.buildToolbarLink('page', currentPage, pageArr[iPage]),
        );
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        var html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingLabel}}/g,
          boostPFSConfig.label.sorting,
        );
        html = html.replace(/{{sortingItems}}/g, sortingItemsHtml);
        return html;
      }
    }
    return '';
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    if (!eventType) eventType = this.eventType;

    // Center no result message
    if (jQ('.boost-pfs-filter-tree').css('display') === 'none') {
      if (!Utils.isSearchPage()) jQ('.collection-filtering-section').css('display', 'none');
      jQ('.large--three-quarters')
        .removeClass('large--three-quarters')
        .addClass('large--four-quarters');
    } else {
      if (!Utils.isSearchPage()) jQ('.collection-filtering-section').css('display', '');
      jQ('.large--four-quarters')
        .removeClass('large--four-quarters')
        .addClass('large--three-quarters');
    }

    resetStyleCollectionImage();

    buildTheme();
  };

  // Build additional elements
  FilterResult.prototype.afterRender = function (data, eventType) {
    if (Utils.isMobile()) {
      resetStyleCollectionImage();
    }
    //custom $ for price range slider
    //       setTimeout(()=> {
    //          jQ('.noUi-handle')[0].innerHTML = '$';
    //       	 jQ('.noUi-handle')[1].innerHTML = '$';
    //       }, 2000);
  };

  // Reset inline style of collection image after clicking pagination or filter to adapt parallax effect
  function resetStyleCollectionImage() {
    jQ('#rellax--collection-image').attr('style', '');
  }

  function buildTheme() {
    // Call theme function
    if (window.wetheme && typeof wetheme.onLoadAll == 'function') {
      wetheme.onLoadAll({});
    }

    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }

    if (Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
      Shopify.PaymentButton.init();
    }

    if (boostPFSConfig.custom.show_multiple_currencies) {
      convertCurrencies();
    }
  }

  /* start-boost-custom */
  /* #boost-135335: customizations */
  Filter.prototype.afterRender = function () {
    var data = this.data;

    var term = 'Product';
    if (data.total_product !== 1) term += 's';

    var totalMsg = `${data.total_product} ${term}`;
    jQ('.boost-pfs-filter-total-products').html(totalMsg);
    jQ('.boost-pfs-filter-total-products').attr(
      'aria-label',
      `${data.total_product} product results`,
    );
  };
  /* end-boost-custom */
})();
